import { installIdvVendorGuards } from './guardIdvVendorRegistration';

try {
  installIdvVendorGuards();
} catch (e) {
  // Fail open so login still loads if guard setup throws (NYLIBS-676).
}
